import Button from "./Buttons/Button";
import Modal from "./Modal";
import styled from "styled-components";
import { ReactComponent as CameraIcon } from "../assets/camera.svg";
import { Image } from "../hooks/useImageUploader";
import ImageCarousel from "./ImageCarousel";
import ImageInputButton from "./Inputs/ImageInputButton";
import { Step } from "./InspectionForm";

interface InspectionFormImagesModalProps {
  step: Step;
  images: Image[];
  show: boolean;
  onAdd: (fileList: FileList) => void;
  onChangeDescription: (
    images: Image[],
    key: string,
    description: string
  ) => void;
  onDeleteImage: (key: string) => void;
  onCancel: () => void;
}

const InspectionFormImageModal = ({
  images,
  show,
  step,
  onAdd,
  onCancel,
  onChangeDescription,
  onDeleteImage,
}: InspectionFormImagesModalProps) => {
  return (
    <Modal show={show} onDismiss={onCancel}>
      <ImagesContainer>
        <Header>
          <IconContainer>
            <CameraIcon />
          </IconContainer>
          <h2>Voeg foto toe</h2>
        </Header>
        <ImageContentContainer>
          <ImageInputButton
            images={images}
            onAdd={onAdd}
            step={step}
            photoLimit={5}
          />
          {Boolean(images.length) && (
            <ImageCarousel
              images={images}
              onChangeDescription={onChangeDescription}
              onDelete={onDeleteImage}
            />
          )}
        </ImageContentContainer>
        <Button
          onClick={() => {
            // onSave(currentNote);
            onCancel();
          }}
          color="green"
          size="medium"
          label="Opslaan"
        />
      </ImagesContainer>
    </Modal>
  );
};

export default InspectionFormImageModal;

const IconContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 30px;
  width: 30px;
  background-color: #0075bc;
  border-radius: 5px;
  margin-right: 12px;
  svg {
    height: 15px;
    width: 15px;
    fill: white;
  }
`;

const ImagesContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 48px;
  textarea {
    height: 154px;
    border: 1px solid #e5e5e5;
    border-radius: 5px;
  }
  button {
    width: 200px;
  }
`;

const ImageContentContainer = styled.div`
  /* width: 240px; */
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  h2 {
    color: #0075bc;
  }
`;
